<script setup lang="ts">
import { PropType } from 'vue'

/* Comnponents */
import DeliveryPointItem from '@/components/Delivery/DeliveryPointItem.vue'

/* Types */
import { PointProperties } from '@/api/modules/delivery/types'

const props = defineProps({
  points: {
    type: Object as PropType<PointProperties[]>,
    required: true,
  },
  selectedPointId: {
    required: true,
    type: Number as PropType<Number | null>,
  },
})

const emit = defineEmits(['setSelectPoint'])

const openMoreInfo = (pointId: number | null) => emit('setSelectPoint', pointId)

const sortedPoints = computed(() => {
  try {
    // Копируем объект, чтобы не было мутации с исходным
    const featuresList: PointProperties[] = JSON.parse(
      JSON.stringify(props.points),
    )

    return featuresList.sort((featureA, featureB) => {
      const distanceA = featureA?.distance || 0
      const distanceB = featureB?.distance || 0

      return distanceA - distanceB
    })
  } catch (_) {
    return props.points
  }
})
</script>

<template>
  <div class="points">
    <ul class="points-list">
      <delivery-point-item
        v-for="(point, index) in sortedPoints"
        :id="`point-${point.id}`"
        :key="point.id"
        :point="point"
        :is-first-point="index === 0"
        :selected-point-id="selectedPointId"
        @open-more-info="openMoreInfo"
      />
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.points {
  &-list {
    display: grid;
    grid-template-columns: 1fr;
    padding: 0;
    list-style: none;
  }
}
</style>
